import { Button } from '@components/Button'
import { UploadCoinButtonFieldProps } from './interface'

export function UploadCoinButtonField({
  src,
  inputRef,
  onChange,
  showUploadDialog,
}: UploadCoinButtonFieldProps) {
  return (
    <div className='relative cursor-pointer'>
      {src && (
        <Button
          onClick={showUploadDialog}
          type='button'
          className='bg-blue-2 font-mitr font-medium text-secondary-100 text-[14px] w-max px-[20px] py-[4px]'
        >
          อัปโหลดใหม่
        </Button>
      )}

      <input
        ref={inputRef}
        className='hidden'
        type='file'
        accept='image/*'
        onChange={onChange}
      />
    </div>
  )
}
